<script setup lang="ts">
definePageMeta({ layout: false })

const localePath = useLocalePath()
</script>

<template>
  <div class="err">
    <i class="err-mark" aria-hidden="true">404</i>
    <p>{{ $t('common.pageNotFound') }}</p>
    <button type="button" @click="navigateTo(localePath('/'))">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 3.2 3.2 11H5v9h5.5v-5.5h3V20H19v-9h1.8L12 3.2z" />
      </svg>
      {{ $t('common.backHome') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.err {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 32px 24px;
  text-align: center;
  background: var(--bg);
  color: var(--text);

  .err-mark {
    display: grid;
    place-items: center;
    width: 168px;
    height: 168px;
    border: 1px solid var(--hairline);
    border-radius: 50%;
    background: var(--surface);
    color: var(--muted);
    font-size: 36px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: 2px;
  }

  p {
    margin: 18px 0 0;
    font-size: 15px;
    font-weight: 600;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 22px;
    font-size: 14px;
    opacity: 0.86;

    svg {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
